import React from "react";

const ToggleSwitch = ({ label, name, checked, onChange, error }) => {
  return (
    <div className="w-full md:w-2/6">
      <label className="mb-2 block text-[17px] text-blue font-bold ">
        {label}
      </label>
      <div className="flex items-center space-x-4">
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${
            checked ? "bg-emerald-500" : "bg-gray-300"
          }`}
          onClick={() => onChange({ target: { name, value: !checked } })}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ${
              checked ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>
      {error && <div className="py-1 text-xs text-red">{error}</div>}
    </div>
  );
};

export default ToggleSwitch;
